<template>
  <div class="centralizadohorizontal">
    <div class="estiloColuna">
      <v-card elevation="2" outlined style="margin-top:1%;height:95%;overflow-y:auto;">

        <v-card-title class="pb-1 pt-3" style="font-size:1.25rem;">
          <v-icon left color="primary">mdi-link-variant</v-icon>
          Associação de Produtos Omie
          <v-spacer />
          <v-btn outlined small color="primary" :loading="sincronizando" :disabled="sincronizando" @click="sincronizarAgora" style="font-size:0.75rem;">
            <v-icon left small>mdi-sync</v-icon>
            Sincronizar agora
          </v-btn>
        </v-card-title>
        <v-card-subtitle class="pb-2" style="margin-top:3px;">
          Vincule produtos do cardápio ao catálogo Omie para sincronização de estoque
        </v-card-subtitle>

        <v-divider />

        <div class="d-flex align-center flex-nowrap" style="padding-right:16px;">
          <v-tabs v-model="tab" color="primary" @change="onTabChange" style="flex:1 1 0;min-width:0;">
            <v-tab>
              Pendentes
              <v-chip v-if="pendentes.length" x-small color="warning" text-color="white" class="ml-2">{{ pendentes.length }}</v-chip>
            </v-tab>
            <v-tab>
              Com erro
              <v-chip v-if="comErro.length" x-small color="error" text-color="white" class="ml-2">{{ comErro.length }}</v-chip>
            </v-tab>
            <v-tab>Todos os produtos</v-tab>
          </v-tabs>
          <v-text-field
            v-model="filtroGlobal"
            placeholder="Buscar produto..."
            prepend-inner-icon="mdi-magnify"
            dense
            outlined
            hide-details
            clearable
            style="flex:0 0 320px;margin-left:24px;"
          />
        </div>

        <v-tabs-items v-model="tab" style="padding-bottom:80px;">

          <!-- Tab: Pendentes -->
          <v-tab-item>
            <v-data-table
              :headers="headersPendentes"
              :items="pendentes"
              :search="filtroGlobal"
              :loading="carregando"
              item-key="idproduto"
              no-data-text="Nenhum produto pendente de associação"
            >
              <template v-slot:item.acoes="{ item }">
                <div class="d-flex align-center" style="gap:8px;padding:6px 0;min-width:340px;">
                  <v-autocomplete
                    v-model="buscaState[item.idproduto].codSelecionado"
                    :items="buscaState[item.idproduto].resultados"
                    :loading="buscaState[item.idproduto].buscando"
                    item-value="codigo_produto"
                    item-text="descricao"
                    placeholder="Buscar produto Omie..."
                    dense
                    outlined
                    hide-details
                    hide-no-data
                    clearable
                    style="max-width:280px;"
                    @update:search-input="val => setTermo(item.idproduto, val)"
                    @keyup.enter="buscarProdutosOmie(item.idproduto)"
                    @click:clear="limparBusca(item.idproduto)"
                    @change="consultarEstoqueProduto(item.idproduto)"
                  >
                    <template v-slot:append>
                      <v-icon style="cursor:pointer" color="primary" @click="buscarProdutosOmie(item.idproduto)">mdi-magnify</v-icon>
                    </template>
                    <template v-slot:item="{ item: r }">
                      <v-list-item-content>
                        <v-list-item-title>{{ r.descricao }}</v-list-item-title>
                        <v-list-item-subtitle style="white-space:normal;line-height:1.3;">
                          <div>Código do produto {{ r.codigo }} · Cód. {{ r.codigo_produto }}</div>
                          <div>R$ {{ r.valor_unitario }}</div>
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </template>
                  </v-autocomplete>
                  <div v-if="buscaState[item.idproduto].codSelecionado" class="d-flex align-center" style="gap:8px;">
                    <v-progress-circular v-if="buscaState[item.idproduto].consultandoSaldo" indeterminate size="18" width="2" color="primary" />
                    <span v-else-if="buscaState[item.idproduto].saldoLocal != null" class="caption text--secondary">
                      Estoque: {{ buscaState[item.idproduto].saldoLocal }}
                    </span>
                    <span v-else-if="buscaState[item.idproduto].erroSaldo" class="caption error--text">
                      {{ buscaState[item.idproduto].erroSaldo }}
                    </span>
                  </div>
                  <v-btn
                    color="success"
                    :disabled="!buscaState[item.idproduto].codSelecionado || buscaState[item.idproduto].consultandoSaldo"
                    @click="associar(item)"
                    style="min-height:40px;font-size:0.75rem;"
                  >
                    <v-icon left small>mdi-link</v-icon>
                    Associar
                  </v-btn>
                </div>
              </template>
            </v-data-table>
          </v-tab-item>

          <!-- Tab: Com erro -->
          <v-tab-item>
            <v-data-table
              :headers="headersErro"
              :items="comErro"
              :search="filtroGlobal"
              :loading="carregando"
              item-key="idproduto"
              no-data-text="Nenhum produto com erro de sincronização"
            >
              <template v-slot:item.acoes="{ item }">
                <div class="d-flex align-center" style="gap:8px;padding:6px 0;min-width:340px;">
                  <v-autocomplete
                    v-model="buscaState[item.idproduto].codSelecionado"
                    :items="buscaState[item.idproduto].resultados"
                    :loading="buscaState[item.idproduto].buscando"
                    item-value="codigo_produto"
                    item-text="descricao"
                    placeholder="Buscar produto Omie..."
                    dense
                    outlined
                    hide-details
                    hide-no-data
                    clearable
                    style="max-width:260px;"
                    @update:search-input="val => setTermo(item.idproduto, val)"
                    @keyup.enter="buscarProdutosOmie(item.idproduto)"
                    @click:clear="limparBusca(item.idproduto)"
                    @change="consultarEstoqueProduto(item.idproduto)"
                  >
                    <template v-slot:append>
                      <v-icon style="cursor:pointer" color="primary" @click="buscarProdutosOmie(item.idproduto)">mdi-magnify</v-icon>
                    </template>
                    <template v-slot:item="{ item: r }">
                      <v-list-item-content>
                        <v-list-item-title>{{ r.descricao }}</v-list-item-title>
                        <v-list-item-subtitle style="white-space:normal;line-height:1.3;">
                          <div>Código do produto {{ r.codigo }} · Cód. {{ r.codigo_produto }}</div>
                          <div>R$ {{ r.valor_unitario }}</div>
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </template>
                  </v-autocomplete>
                  <div v-if="buscaState[item.idproduto].codSelecionado" class="d-flex align-center" style="gap:8px;">
                    <v-progress-circular v-if="buscaState[item.idproduto].consultandoSaldo" indeterminate size="18" width="2" color="primary" />
                    <span v-else-if="buscaState[item.idproduto].saldoLocal != null" class="caption text--secondary">
                      Estoque: {{ buscaState[item.idproduto].saldoLocal }}
                    </span>
                    <span v-else-if="buscaState[item.idproduto].erroSaldo" class="caption error--text">
                      {{ buscaState[item.idproduto].erroSaldo }}
                    </span>
                  </div>
                  <v-btn
                    color="warning"
                    :disabled="!buscaState[item.idproduto].codSelecionado || buscaState[item.idproduto].consultandoSaldo"
                    @click="associar(item)"
                    style="height:40px;"
                  >
                    <v-icon left small>mdi-link-variant</v-icon>
                    Re-associar
                  </v-btn>
                </div>
              </template>
            </v-data-table>
          </v-tab-item>

          <!-- Tab: Todos os produtos -->
          <v-tab-item>
            <div class="d-flex flex-wrap align-center" style="gap:12px;padding:12px 16px;">
              <v-select
                v-model="filtros.controla_estoque"
                :items="opcoesControlaEstoque"
                label="Controle de estoque"
                clearable
                dense
                outlined
                hide-details
                style="max-width:200px;"
                @change="getProdutosEstoque"
              />
              <v-select
                v-model="filtros.status_sincronizacao_omie"
                :items="statusOptions"
                item-text="label"
                item-value="valor"
                label="Status"
                clearable
                dense
                outlined
                hide-details
                style="max-width:200px;"
                @change="getProdutosEstoque"
              />
              <v-btn outlined @click="getProdutosEstoque" :loading="carregandoProdutos" style="height:40px;">
                <v-icon left>mdi-refresh</v-icon>
                Atualizar
              </v-btn>
            </div>

            <v-data-table
              :headers="headersTodos"
              :items="todosProdutos"
              :search="filtroGlobal"
              :loading="carregandoProdutos"
              item-key="idproduto"
              dense
              no-data-text="Nenhum produto encontrado"
            >
              <template v-slot:item.controla_estoque="{ item }">
                <v-switch
                  v-model="item.controla_estoque"
                  dense
                  hide-details
                  class="mt-0 pt-0"
                  @change="val => toggleControlaEstoque(item, val)"
                />
              </template>
              <template v-slot:item.status_sincronizacao_omie="{ item }">
                <v-chip x-small :color="corStatus(item.status_sincronizacao_omie)" text-color="white">
                  {{ labelStatus(item.status_sincronizacao_omie) }}
                </v-chip>
              </template>
              <template v-slot:item.estoque_omie_atual="{ item }">
                <span :class="estoqueAbaixoMinimo(item) ? 'error--text font-weight-bold' : ''">
                  <v-icon v-if="estoqueAbaixoMinimo(item)" x-small color="error" class="mr-1">mdi-alert</v-icon>
                  {{ item.estoque_omie_atual != null ? item.estoque_omie_atual : '—' }}
                </span>
              </template>
              <template v-slot:item.estoque_sincronizado_em="{ item }">
                <span class="caption text--secondary">{{ formatarData(item.estoque_sincronizado_em) }}</span>
              </template>
              <template v-slot:item.acoes="{ item }">
                <v-btn v-if="item.cod_produto_omie" x-small outlined color="error" @click="abrirDesassociar(item)">
                  <v-icon left x-small>mdi-link-off</v-icon>
                  Desassociar
                </v-btn>
              </template>
            </v-data-table>
          </v-tab-item>

        </v-tabs-items>
      </v-card>
    </div>

    <!-- Modal de conflito ao tentar associar produto Omie já vinculado a outro grupo. -->
    <v-dialog v-model="conflito.aberto" max-width="640" persistent>
      <v-card>
        <v-card-title style="font-size:1.1rem;">
          <v-icon left color="warning">mdi-alert</v-icon>
          O produto {{ conflito.descOmie || conflito.cod_produto_omie }}
        </v-card-title>
        <v-card-subtitle style="padding-top:8px;">
          já está vinculado a outro produto do cardápio. Escolha qual associação deseja manter:
        </v-card-subtitle>
        <v-card-text>
          <v-radio-group v-model="conflito.escolha" hide-details class="mt-0 pt-0">
            <div class="d-flex align-stretch" style="gap:12px;">
              <v-card outlined style="flex:1 1 0;min-width:0;cursor:pointer;padding:10px;display:flex;align-items:center;" @click="conflito.escolha = 'existente'">
                <v-radio value="existente">
                  <template v-slot:label>
                    <div style="min-width:0;">
                      <div class="caption text--secondary">Associação atual</div>
                      <div style="font-weight:500;word-break:break-word;">{{ conflito.existenteLabel }}</div>
                    </div>
                  </template>
                </v-radio>
              </v-card>
              <v-card outlined style="flex:1 1 0;min-width:0;cursor:pointer;padding:10px;display:flex;align-items:center;" @click="conflito.escolha = 'novo'">
                <v-radio value="novo">
                  <template v-slot:label>
                    <div style="min-width:0;">
                      <div class="caption text--secondary">Mover para</div>
                      <div style="font-weight:500;word-break:break-word;">{{ conflito.novoLabel }}</div>
                    </div>
                  </template>
                </v-radio>
              </v-card>
            </div>
          </v-radio-group>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="cancelarConflito">Cancelar</v-btn>
          <v-btn color="primary" @click="confirmarConflito">Salvar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Confirmação de desassociação. -->
    <v-dialog v-model="desassociar.aberto" max-width="520" persistent>
      <v-card>
        <v-card-title style="font-size:1.1rem;">
          <v-icon left color="warning">mdi-alert</v-icon>
          Desassociar produto
        </v-card-title>
        <v-card-text style="padding-top:16px;">
          O produto <strong>{{ desassociar.descproduto }}</strong> será desassociado do catálogo Omie. Deseja continuar?
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="cancelarDesassociar">Cancelar</v-btn>
          <v-btn color="error" @click="confirmarDesassociar">Desassociar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Confirmação da ação de mover associação. Mesmo tamanho e posição do modal de conflito. -->
    <v-dialog v-model="confirmacao.aberto" max-width="640" persistent>
      <v-card>
        <v-card-title style="font-size:1.1rem;">
          <v-icon left color="warning">mdi-alert</v-icon>
          Confirmar movimentação
        </v-card-title>
        <v-card-text style="padding-top:16px;">
          A associação atual com <strong>{{ conflito.existenteLabel }}</strong> será desfeita, e o produto Omie <strong>{{ conflito.descOmie || conflito.cod_produto_omie }}</strong> passará a ficar vinculado a <strong>{{ conflito.novoLabel }}</strong>. Deseja continuar?
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="cancelarConfirmacao">Cancelar</v-btn>
          <v-btn color="primary" @click="confirmarMover">Confirmar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: 'AssociacaoOmie',
  data () {
    return {
      tab: 0,
      carregando: false,
      carregandoProdutos: false,
      sincronizando: false,
      pendentes: [],
      comErro: [],
      filtroGlobal: '',
      conflito: {
        aberto: false,
        cod_produto_omie: null,
        descOmie: '',
        existenteLabel: '',
        novoLabel: '',
        escolha: 'existente',
        payloadPendente: null,
      },
      confirmacao: {
        aberto: false,
      },
      desassociar: {
        aberto: false,
        cod_produto_omie: null,
        descproduto: '',
      },
      todosProdutos: [],
      statusOptions: [],
      buscaState: {},
      filtros: {
        controla_estoque: null,
        status_sincronizacao_omie: null,
        nome: '',
      },
      opcoesControlaEstoque: [
        { text: 'Com controle ativo', value: 'true' },
        { text: 'Sem controle', value: 'false' },
      ],
      headersPendentes: [
        { text: 'ID', value: 'idproduto', width: '80px' },
        { text: 'Produto interno', value: 'descproduto' },
        { text: 'CD', value: 'nomecd' },
        { text: 'Buscar / Associar', value: 'acoes', sortable: false }
      ],
      headersErro: [
        { text: 'ID', value: 'idproduto', width: '80px' },
        { text: 'Produto interno', value: 'descproduto' },
        { text: 'CD', value: 'nomecd' },
        { text: 'Cód. Omie', value: 'cod_produto_omie', width: '120px' },
        { text: 'Buscar / Re-associar', value: 'acoes', sortable: false }
      ],
      headersTodos: [
        { text: 'ID', value: 'idproduto', width: '80px' },
        { text: 'Produto interno', value: 'descproduto' },
        { text: 'CD', value: 'nomecd' },
        { text: 'Cód. Omie', value: 'cod_produto_omie', width: '120px' },
        { text: 'Controle', value: 'controla_estoque', sortable: false, width: '100px' },
        { text: 'Estoque atual', value: 'estoque_omie_atual', width: '120px' },
        { text: 'Mínimo', value: 'estoque_minimo_omie', width: '90px' },
        { text: 'Status', value: 'status_sincronizacao_omie', width: '160px' },
        { text: 'Sincronizado em', value: 'estoque_sincronizado_em' },
        { text: 'Ações', value: 'acoes', sortable: false, width: '120px' },
      ]
    }
  },
  created () {
    this._termos = {}
    this._debounceSaldo = {}
  },
  mounted () {
    this.$store.dispatch('set_titulo', 'Associação Omie')
    this.getPendencias()
    this.getStatusOptions()
  },
  methods: {
    onTabChange (tab) {
      if (tab === 2 && this.todosProdutos.length === 0) {
        this.getProdutosEstoque()
      }
    },
    async getPendencias () {
      this.carregando = true
      try {
        const response = await this.$http.get('pdv/omie/pendencias')
        const { pendentes, comErro } = response.data
        this.pendentes = pendentes || []
        this.comErro = comErro || []
        ;[...this.pendentes, ...this.comErro].forEach(p => {
          if (!this.buscaState[p.idproduto]) {
            this.$set(this.buscaState, p.idproduto, { resultados: [], buscando: false, codSelecionado: null, localSelecionado: null, saldoLocal: null, erroSaldo: '', consultandoSaldo: false })
          }
        })
      } catch (error) {
        console.log(error)
        this.$alertar('warning', 'Não foi possível carregar as pendências de associação Omie', '=(')
      } finally {
        this.carregando = false
      }
    },
    async getStatusOptions () {
      try {
        const response = await this.$http.get('pdv/omie/statusSincronizacao')
        this.statusOptions = response.data
      } catch (e) {
        // silencioso
      }
    },
    async getProdutosEstoque () {
      this.carregandoProdutos = true
      try {
        const params = {}
        if (this.filtros.controla_estoque != null) params.controla_estoque = this.filtros.controla_estoque
        if (this.filtros.status_sincronizacao_omie) params.status_sincronizacao_omie = this.filtros.status_sincronizacao_omie
        const response = await this.$http.get('pdv/omie/produtosEstoque', { params })
        this.todosProdutos = response.data
      } catch (e) {
        this.$alertar('warning', 'Erro ao carregar produtos', '=(')
      } finally {
        this.carregandoProdutos = false
      }
    },
    async toggleControlaEstoque (item, novoValor) {
      const valorAnterior = !novoValor
      try {
        await this.$http.put('pdv/produto/cadastro', { idproduto: item.idproduto, descproduto: item.descproduto, controla_estoque: novoValor })
        this.$alertar('success', novoValor ? 'Controle ativado' : 'Controle desativado', '=)')
      } catch (e) {
        item.controla_estoque = valorAnterior
        this.$alertar('warning', 'Erro ao atualizar', '=(')
      }
    },
    setTermo (idproduto, val) {
      this._termos[idproduto] = val || ''
    },
    limparBusca (idproduto) {
      const state = this.buscaState[idproduto]
      if (!state) return
      state.resultados = []
      state.codSelecionado = null
      state.localSelecionado = null
      state.saldoLocal = null
      state.erroSaldo = ''
      state.consultandoSaldo = false
      this._termos[idproduto] = ''
    },
    async consultarEstoqueProduto (idproduto) {
      const state = this.buscaState[idproduto]
      if (!state || !state.codSelecionado) return
      state.consultandoSaldo = true
      state.saldoLocal = null
      state.erroSaldo = ''
      try {
        const response = await this.$http.get('pdv/omie/saldoProdutoLocal', {
          params: { cod_produto_omie: state.codSelecionado, codigo_local_estoque: 0 },
        })
        state.saldoLocal = response.data && response.data.saldo != null ? response.data.saldo : null
        if (state.saldoLocal == null && response.data && typeof response.data.mensagem === 'string') {
          state.erroSaldo = response.data.mensagem
        } else if (state.saldoLocal == null) {
          state.erroSaldo = 'Produto sem posição no estoque padrão'
        }
      } catch (e) {
        const dados = e && e.response && e.response.data
        let msg
        if (dados && typeof dados.message === 'string') msg = dados.message
        else if (typeof dados === 'string') msg = dados
        state.erroSaldo = msg || 'Erro ao consultar estoque'
      } finally {
        state.consultandoSaldo = false
      }
    },
    async buscarProdutosOmie (idproduto) {
      const state = this.buscaState[idproduto]
      if (!state) return
      const termo = this._termos[idproduto] || ''
      if (!termo) { state.resultados = []; return }
      state.buscando = true
      try {
        const response = await this.$http.get('pdv/omie/buscarProdutos', { params: { termo } })
        state.resultados = response.data || []
      } catch (e) {
        this.$alertar('warning', 'Erro na busca Omie', '=(')
      } finally {
        state.buscando = false
      }
    },
    async sincronizarAgora () {
      this.sincronizando = true
      try {
        await this.$http.post('pdv/omie/sincronizarAgora')
        this.$alertar('success', 'Sincronização iniciada', '=)')
        await this.getPendencias()
      } catch (e) {
        this.$alertar('warning', 'Erro ao sincronizar', '=(')
      } finally {
        this.sincronizando = false
      }
    },
    async associar (item) {
      const state = this.buscaState[item.idproduto]
      if (!state.codSelecionado) { this.$alertar('warning', 'Selecione um produto Omie', ''); return }
      // Envia o array de irmãos (todas as categorias do mesmo codprodutopms).
      const idprodutos = Array.isArray(item.idprodutos) && item.idprodutos.length
        ? item.idprodutos
        : [item.idproduto]
      const selecionado = (state.resultados || []).find(r => String(r.codigo_produto) === String(state.codSelecionado))
      const descOmie = selecionado ? selecionado.descricao : null
      await this.enviarAssociacao({
        idprodutos,
        cod_produto_omie: state.codSelecionado,
        novoLabel: item.descproduto,
        descOmie,
        representante: item.idproduto,
      })
    },
    async enviarAssociacao ({ idprodutos, cod_produto_omie, codigo_local_estoque_omie, forcar, novoLabel, descOmie, representante }) {
      try {
        const payload = { idprodutos, cod_produto_omie }
        if (codigo_local_estoque_omie != null) payload.codigo_local_estoque_omie = codigo_local_estoque_omie
        if (forcar) payload.forcar = true
        await this.$http.post('pdv/omie/associarProduto', payload)
        this.$alertar('success', 'Produto(s) associado(s)', '=)')
        if (representante != null) {
          this.$set(this.buscaState, representante, { resultados: [], buscando: false, codSelecionado: null, localSelecionado: null, saldoLocal: null, erroSaldo: '', consultandoSaldo: false })
          this._termos[representante] = ''
        }
        this.conflito.aberto = false
        this.conflito.payloadPendente = null
        await this.getPendencias()
      } catch (e) {
        // 409 indica cod_produto_omie em uso em outro grupo.
        const resp = e && e.response
        if (resp && resp.status === 409 && resp.data && resp.data.conflito) {
          const ex = resp.data.conflito.existente
          this.conflito.cod_produto_omie = resp.data.conflito.cod_produto_omie
          this.conflito.descOmie = descOmie || ''
          this.conflito.existenteLabel = ex.descproduto
          this.conflito.novoLabel = novoLabel || 'novo grupo'
          this.conflito.escolha = 'existente'
          this.conflito.payloadPendente = { idprodutos, cod_produto_omie, codigo_local_estoque_omie, novoLabel, descOmie, representante }
          this.conflito.aberto = true
          return
        }
        this.$alertar('warning', 'Erro ao associar produto', '=(')
      }
    },
    cancelarConflito () {
      this.conflito.aberto = false
      this.conflito.payloadPendente = null
    },
    async confirmarConflito () {
      if (this.conflito.escolha === 'existente') {
        this.cancelarConflito()
        return
      }
      this.confirmacao.aberto = true
    },
    cancelarConfirmacao () {
      this.confirmacao.aberto = false
    },
    abrirDesassociar (item) {
      this.desassociar.cod_produto_omie = item.cod_produto_omie
      this.desassociar.descproduto = item.descproduto
      this.desassociar.aberto = true
    },
    cancelarDesassociar () {
      this.desassociar.aberto = false
    },
    async confirmarDesassociar () {
      try {
        await this.$http.post('pdv/omie/desassociarProduto', { cod_produto_omie: this.desassociar.cod_produto_omie })
        this.$alertar('success', 'Produto desassociado', '=)')
        this.desassociar.aberto = false
        await Promise.all([this.getPendencias(), this.getProdutosEstoque()])
      } catch (e) {
        this.$alertar('warning', 'Erro ao desassociar produto', '=(')
      }
    },
    async confirmarMover () {
      const pendente = this.conflito.payloadPendente
      this.confirmacao.aberto = false
      if (!pendente) return
      await this.enviarAssociacao({ ...pendente, forcar: true })
    },
    estoqueAbaixoMinimo (item) {
      return item.estoque_omie_atual != null && item.estoque_minimo_omie != null && item.estoque_omie_atual <= item.estoque_minimo_omie
    },
    formatarData (v) {
      if (!v) return '—'
      const d = new Date(v)
      if (isNaN(d)) return v
      return d.toLocaleString('pt-BR', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' })
    },
    corStatus (status) {
      const cores = { OK: 'success', ERRO: 'error', PENDENTE_ASSOCIACAO: 'warning' }
      return cores[status] || 'grey'
    },
    labelStatus (status) {
      const op = this.statusOptions.find(s => s.valor === status)
      return op ? op.label : (status || '—')
    },
  }
}
</script>

<style scoped>
</style>
